import React from 'react';

export const PeriodEndsContext = React.createContext(
    {
        view: "stages",
        setView: () => {}
    }
)